module.exports = __webpack_public_path__ + "img/login-obj.d9b65a2c.png";